// Lightweight localStorage helper to persist and retrieve recent material selections (keyed by tenant/user).
const STORAGE_PREFIX = "recent-materials";
const MAX_RECENTS = 20;

const getStorageKey = (tenantId: string, userId: string) => {
  const safeTenant = tenantId || "defaultTenant";
  const safeUser = userId || "anonymous";
  return `${STORAGE_PREFIX}:${safeTenant}:${safeUser}`;
};

export const addRecentMaterial = (tenantId: string, userId: string, materialId: string) => {
  if (typeof window === "undefined") return;
  try {
    const key = getStorageKey(tenantId, userId);
    const raw = window.localStorage.getItem(key);
    const existing: string[] = raw ? JSON.parse(raw) : [];
    const filtered = existing.filter((id) => id !== materialId);
    const next = [materialId, ...filtered].slice(0, MAX_RECENTS);
    window.localStorage.setItem(key, JSON.stringify(next));
  } catch (err) {
    console.warn("Impossible d'enregistrer la matière récente", err);
  }
};

export const getRecentMaterials = (tenantId: string, userId: string, limit = 6): string[] => {
  if (typeof window === "undefined") return [];
  try {
    const key = getStorageKey(tenantId, userId);
    const raw = window.localStorage.getItem(key);
    const existing: string[] = raw ? JSON.parse(raw) : [];
    return existing.slice(0, limit);
  } catch {
    return [];
  }
};
